import React from 'react';
import {Link} from 'react-router-dom';

import Header from './Header.component';
import Contact from './Contact.component';
import Footer from './Footer.component';

const Main = () => {
  return (
    <React.Fragment>
      <Header />
      <div id='main'>
        <section id='one' className='tiles'>
          <article>
            <span className='image'>
              <img src='assets/images/bridal01.jpg' alt='Bridals-01' title='Bridals-01' />
            </span>
            <header className='major'>
              <h3>
                <span>Bridals</span>
              </h3>
              <p>To The Altar</p>
            </header>
          </article>

          <article>
            <span className='image'>
              <img src='assets/images/reception02.png' alt='Bridals-02' title='Bridals-02' />
            </span>
            <header className='major'>
              <h3>
                <span>Bridals</span>
              </h3>
              <p>Happily After</p>
            </header>
          </article>

          <article>
            <span className='image'>
              <img src='assets/images/official01.jpg' alt='Official-role' title='Official-role' />
            </span>
            <header className='major'>
              <h3>
                <span>Career Life</span>
              </h3>
              <p>Mainstream Trends</p>
            </header>
          </article>

          <article>
            <span className='image'>
              <img src='assets/images/casual.png' alt='Casual-role' title='Casual-role' />
            </span>
            <header className='major'>
              <h3>
                <span>Simple Casual</span>
              </h3>
              <p>Sleek & Style</p>
            </header>
          </article>
          <article>
            <span className='image'>
              <img src='assets/images/traditional02.jpg' alt='Traditional-role' title='Traditional-role' />
            </span>
            <header className='major'>
              <h3>
                <span>Centerpiece</span>
              </h3>
              <p>Our Style</p>
            </header>
          </article>

          <article>
            <span className='image'>
              <img src='assets/images/traditional01.jpg' alt='Traditional-role' title='Traditional-role' />
            </span>
            <header className='major'>
              <h3>
                <span>Fashion Fair</span>
              </h3>
              <p>African Beauty</p>
            </header>
          </article>
        </section>

        <section id='two'>
          <div className='inner'>
            <header className='major'>
              <h2>Philosophy</h2>
            </header>
            <p>
              The fashion industry keeps evolving and has continued to carve out its own niche in the
              mainstream and consistently remained in the spotlight, as a result of this we are adaptive to
              innovations giving you the best to make you stand in amazing elegance.{' '}
            </p>
            <ul className='actions'>
              <li>
                <Link to='/gallery' className='button next'>
                  Gallery
                </Link>
              </li>
            </ul>
          </div>
        </section>
      </div>

      <Contact />
      <Footer />
    </React.Fragment>
  );
};

export default Main;
